import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_PARTNER_LISTING_HOUSEHOLDS_APPLYING } from 'api/actionTypes';

export default async function getHouseholdsApplyingToListing(
  { state, apiClient },
  { listingId, includeAllHouseholdDataToChecklist, forceRefresh = false },
) {
  typeCheck('listingId::PositiveNumber', listingId);

  const currentPartnerStatePath = ['partners', 'householdsApplyingByListingId', String(listingId)];
  if (state.get(currentPartnerStatePath) && !forceRefresh) {
    return state.get(currentPartnerStatePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_LISTING_HOUSEHOLDS_APPLYING,
    queryId: listingId,
    state: state,
    payload: {
      listingId,
      includeAllHouseholdDataToChecklist,
    },
    onSuccess(householdsApplying) {
      if (householdsApplying) {
        state.set(currentPartnerStatePath, householdsApplying);
      }
    },
  });
}
